export default "__VITE_ASSET__3ff15887__"